var _rect, _g, _text, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _text2, _text3, _path, _path2, _line7, _g2, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _g3, _text12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcoAoLongoDoDia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 700",
    fontFamily: "Inter, sans-serif",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 700,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#E2E4E9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 154,
    x2: 1030,
    y2: 154
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 194,
    x2: 1030,
    y2: 194
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 234,
    x2: 1030,
    y2: 234
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 274,
    x2: 1030,
    y2: 274
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 314,
    x2: 1030,
    y2: 314
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 354,
    x2: 1030,
    y2: 354
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 430,
    x2: 1030,
    y2: 430
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 465,
    x2: 1030,
    y2: 465
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 500,
    x2: 1030,
    y2: 500
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 535,
    x2: 1030,
    y2: 535
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 30,
    fontSize: 20,
    fontWeight: 600,
    fill: "#0A0D14"
  }, "Modo ECO ao Longo de um Dia")), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 54,
    fontSize: 13,
    fill: "#525866",
    style: {
      display: "none"
    }
  }, "Como a temperatura ambiente comanda os est\xE1gios de capacidade, do in\xEDcio ao fim da programa\xE7\xE3o hor\xE1ria."), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 130,
    fontSize: 12,
    fontWeight: 600,
    fill: "#86909C",
    style: {
      display: "none"
    }
  }, "Temperatura ambiente"), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 210,
    width: 840,
    height: 40,
    fill: "#EEF4FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 350,
    width: 840,
    height: 20,
    fill: "#FFFBEC"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 210,
    x2: 1030,
    y2: 210,
    stroke: "#C8D8FD",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 250,
    x2: 1030,
    y2: 250,
    stroke: "#C8D8FD",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 230,
    x2: 1030,
    y2: 230,
    stroke: "#86909C",
    strokeWidth: 1,
    strokeDasharray: "5 4"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 350,
    x2: 1030,
    y2: 350,
    stroke: "#F28602",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 310,
    y1: 110,
    x2: 310,
    y2: 535,
    stroke: "#363BC4",
    strokeWidth: 1,
    strokeDasharray: "4 4"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 910,
    y1: 110,
    x2: 910,
    y2: 535,
    stroke: "#363BC4",
    strokeWidth: 1,
    strokeDasharray: "4 4"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 318,
    y: 126,
    fontSize: 12,
    fontWeight: 600,
    fill: "#363BC4"
  }, "ECO habilitado")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 902,
    y: 126,
    fontSize: 12,
    fontWeight: 600,
    fill: "#363BC4",
    textAnchor: "end"
  }, "ECO desabilitado")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190,288 L230,282 L272,280 L305,272 L328,252 L350,232 L384,224 L428,218 L460,214 L482,210 L488,202 L490,206 L497,252 L505,258 L517,262 L550,266 L574,270 L619,294 L664,326 L678,340 L690,350 L705,362 L720,350 L740,326 L776,286 L809,250 L821,240 L866,224 L910,218 L955,202 L1030,178",
    fill: "none",
    stroke: "#F93A3A",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 412,
    fontSize: 12,
    fontWeight: 600,
    fill: "#86909C",
    style: {
      display: "none"
    }
  }, "Capacidade da m\xE1quina"), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190,535 H280 V500 H482 V465 H490 V430 H505 V465 H517 V500 H690 V535 H809 V500 H940 V535 H1030",
    fill: "none",
    stroke: "#363BC4",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 555,
    x2: 1030,
    y2: 555,
    stroke: "#E2E4E9",
    strokeWidth: 1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 154,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "28 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 194,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "26 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 234,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "24 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 274,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "22 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 314,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "20 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 354,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "18 \xB0C"), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 555,
    x2: 190,
    y2: 561,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310,
    y1: 555,
    x2: 310,
    y2: 561,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430,
    y1: 555,
    x2: 430,
    y2: 561,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 555,
    x2: 550,
    y2: 561,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 555,
    x2: 670,
    y2: 561,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 790,
    y1: 555,
    x2: 790,
    y2: 561,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 910,
    y1: 555,
    x2: 910,
    y2: 561,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1030,
    y1: 555,
    x2: 1030,
    y2: 561,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 575,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "06:00"), /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 575,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "08:00"), /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 575,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "10:00"), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 575,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "12:00"), /*#__PURE__*/React.createElement("text", {
    x: 670,
    y: 575,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "14:00"), /*#__PURE__*/React.createElement("text", {
    x: 790,
    y: 575,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "16:00"), /*#__PURE__*/React.createElement("text", {
    x: 910,
    y: 575,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "18:00"), /*#__PURE__*/React.createElement("text", {
    x: 1030,
    y: 575,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "20:00"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 434,
    fontSize: 12,
    fill: "#525866"
  }, "Capacidade total")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 214,
    fontSize: 12,
    fill: "#363BC4"
  }, "Setpoint + histerese superior")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 234,
    fontSize: 12,
    fill: "#525866"
  }, "Setpoint")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 254,
    fontSize: 12,
    fill: "#363BC4"
  }, "Setpoint \u2212 histerese inferior")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 354,
    fontSize: 12,
    fill: "#CA6704"
  }, "LTI")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 469,
    fontSize: 12,
    fill: "#525866"
  }, "Capacidade parcial")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 504,
    fontSize: 12,
    fill: "#525866"
  }, "Ventila\xE7\xE3o")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 539,
    fontSize: 12,
    fill: "#525866"
  }, "Desligado")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 615,
    x2: 214,
    y2: 615,
    stroke: "#F93A3A",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 222,
    y: 619,
    fontSize: 12,
    fill: "#525866"
  }, "Temperatura ambiente"), /*#__PURE__*/React.createElement("path", {
    d: "M400,620 H406 V615 H412 V610 H418",
    fill: "none",
    stroke: "#363BC4",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 428,
    y: 619,
    fontSize: 12,
    fill: "#525866"
  }, "Capacidade da m\xE1quina"), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 609,
    width: 18,
    height: 12,
    fill: "#EEF4FF",
    stroke: "#C8D8FD"
  }), /*#__PURE__*/React.createElement("text", {
    x: 646,
    y: 619,
    fontSize: 12,
    fill: "#525866"
  }, "Faixa confort\xE1vel"), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 645,
    x2: 214,
    y2: 645,
    stroke: "#F28602",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 222,
    y: 649,
    fontSize: 12,
    fill: "#525866"
  }, "Limite de temperatura baixa (LTI)"), /*#__PURE__*/React.createElement("line", {
    x1: 490,
    y1: 637,
    x2: 490,
    y2: 653,
    stroke: "#363BC4",
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 502,
    y: 649,
    fontSize: 12,
    fill: "#525866"
  }, "In\xEDcio e fim do ECO na programa\xE7\xE3o hor\xE1ria"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 678,
    fontSize: 12,
    fill: "#86909C"
  }, "Setpoint 24 \xB0C \xB7 histereses 1 \xB0C \xB7 limite de temperatura baixa 18 \xB0C \xB7 atraso para adicionar est\xE1gio 8 min \xB7 atraso para reduzir est\xE1gio 12 min")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoAoLongoDoDia);
export default __webpack_public_path__ + "static/media/eco-ao-longo-do-dia.95822046e3e49c698d70d0637768b530.svg";
export { ForwardRef as ReactComponent };